import { useCallback, useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import type { Solicitud } from "@/types";

export function useSolicitudes() {
  const [solicitudes, setSolicitudes] = useState<Solicitud[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const { data, error: queryError } = await supabase
        .from("solicitudes_de_servicio")
        .select("*")
        .order("creado_en", { ascending: false });
      if (queryError) throw queryError;
      setSolicitudes((data as Solicitud[]) ?? []);
    } catch {
      setError("No pudimos cargar las solicitudes. Revisa tu conexión e intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  return { solicitudes, loading, error, reload: load, setSolicitudes };
}